import React, { useEffect } from "react";
import SingleImageUploader from "./SingleImageUploader";
import MultiFileUploader from "./MultiFileUploader";
import FormType from "features/Enums/FormType";
import { useDispatch, useSelector } from "react-redux";
import { getAttachments } from "./AttachmentsAPI";
const AttachmentComponent = (props) => {
  const dispatch = useDispatch();
  const isSingleUpload = new Set([
    FormType.ProductsAndServices.id,
    FormType.MappedCompany.id,
  ]).has(props?.identifier);

  useEffect(() => {
    if (props?.identifier && props?.currentId && props?.getattachments) {
      dispatch(getAttachments(props?.currentId, props?.identifier));
    }
  }, [props?.identifier, props?.getattachments]);

  return isSingleUpload ? (
    <SingleImageUploader {...props} />
  ) : (
    <MultiFileUploader
      {...props}
      value={props?.value}
      onChange={props?.onChange}
    />
  );
};

export default AttachmentComponent;
